import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuth } from '../../context/AuthContext';
import { BsCaretDownFill, BsCaretUpFill } from 'react-icons/bs';
import axios from 'axios';
import validator from 'email-validator';

const Register = () => {

  const API_URL = process.env.REACT_APP_FIREBASE_API_URL_SERVER;

  const navigate = useNavigate();
  const { createUser } = UserAuth();

  const [username, setUsername] = useState('');
  const isValid = /^[a-zA-Z0-9]+$/.test(username);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [agentID, setAgentID] = useState('');
  const [error, setError] = useState('');

  const [loading, setLoading] = useState();
  const [showNotification, setShowNotification] = useState(false);
  const [showInput, setShowInput] = useState();
  const [timeoutId, setTimeoutId] = useState(null);

  /* Form Data */
  const formData = [
    { id: 'username', title: 'Username' },
    { id: 'email', title: 'Email' },
    { id: 'password', title: 'Password' },
  ]

  /* Handle Form Input */
  const setHandleInput = (id, e) => {
    if (id === 'username') {
      setUsername(e.target.value.toLowerCase());
    } else if (id === 'password') {
      setPassword(e.target.value);
    } else if (id === 'email') {
      setEmail(e.target.value.toLowerCase());
    }
  };

  const setTypeInput = (id) => {
    if (id === 'password') {
      return "password";
    } else {
      return "text";
    }
  }

  /* Render Form */
  const formElement = formData.map((hasil, i) =>
    <label className="block">
      <span className="text-gray-700">{hasil.title}</span>
      <input onChange={(e) => setHandleInput(hasil.id, e)} type={setTypeInput(hasil.id)} className="mt-0 block w-full pl-1 pr-1 px-1 border-0 border-b border-black focus:ring-0 focus:border-primary" autoComplete="off" />
    </label>
  );

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowNotification(false)
    setLoading(true);
    try {
      if (!username) {
        throw new Error('Username harus diisi');
      }
      if (username.indexOf(" ") !== -1) {
        throw new Error('Username tidak boleh menggunakan spasi');
      }
      if (!isValid) {
        throw new Error('Username hanya boleh terdiri dari angka atau huruf');
      }
      if (!/[a-zA-Z]/.test(username)) {
        throw new Error('Username setidaknya terdiri dari satu huruf');
      }
      if (username.length < 4) {
        throw new Error('Username minimal 4 karakter');
      }
      if (username.length > 16) {
        throw new Error('Username maksimal 16 karakter');
      }
      if (!email) {
        throw new Error('Email harus diisi');
      }
      if (!validator.validate(email)) {
        throw new Error('Email tidak valid');
      }
      if (email.length < 5) {
        throw new Error('Email minimal 5 karakter');
      }
      if (email.length > 64) {
        throw new Error('Email maksimal 64 karakter');
      }
      if (!password) {
        throw new Error('Password harus diisi');
      }
      if (password.length > 32) {
        throw new Error('Password maksimal 32 karakter');
      }
      if (password.length < 6) {
        throw new Error('Password minimal 6 karakter');
      }
      if (agentID.length > 64) {
        throw new Error('Kode referal maksimal 64 karakter');
      }
      const response = await axios.post(API_URL + 'api/checkUsername', { username: username })
      if (response.data.response === true) {
        throw new Error('Username telah terdaftar');
      }
      if (response.data.response === false) {
        await createUser(username, email, password, agentID);
        navigate('/');
      }
    } catch (e) {
      setShowNotification(true);
      switch (e.code) {
        case 'auth/weak-password':
          setError('Password minimal 6 karakter');
          break;
        case 'auth/email-already-in-use':
          setError('Email telah terdaftar');
          break;
        case 'auth/invalid-email':
          setError('Email tidak valid');
          break;
        case 'auth/operation-not-allowed':
          setError('Pendaftaran akun sudah ditutup');
          break;
        default:
          setError(e.message);
          break;
      }
    } finally {
      setLoading(false);
    }
    setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
  };

  return (
    <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }}>

      <div className="max-w-[600px] mx-auto max-h-screen min-h-screen bg-white shadow-2xl border-4 border-primary md:border-0 relative">
        {loading && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center">
            <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
          </div>
        )}
        {showNotification && (
          <div className="px-4 fixed bottom-0 w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up">
            <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
              {error}
              <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
            </div>
          </div>
        )}
        <div className="p-4 border-b">
          <h1 className="font-medium text-md">Buat akun IziUSE</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 gap-6 p-4">
            {formElement}
            <label className="block">
              <span className="text-gray-700 flex items-center cursor-pointer">Kode Referal (Jika Ada)
                {showInput ? (
                  <BsCaretUpFill className='ml-1 fill-current text-gray-400' size='14' onClick={() => setShowInput(!showInput)} />
                ) : (
                  <BsCaretDownFill className='ml-1 fill-current text-gray-400' size='14' onClick={() => setShowInput(!showInput)} />
                )}
              </span>
              {showInput && (
                <input onChange={(e) => setAgentID(e.target.value)} type="text" className="mt-0 block w-full pl-1 pr-1 px-1 border-0 border-b border-black focus:ring-0 focus:border-primary" autoComplete="off" />
              )}
            </label>
            <label className="block">
              <p className="text-xs text-gray-600">Dengan membuat akun IziUSE berarti anda telah menyetujui <Link className="text-xs hover:underline text-primary font-medium" to="/signup">syarat dan ketentuan layanan.</Link></p>

            </label>
            <label className="block">
              <button className="w-full px-4 py-2 rounded-md font-semibold text-white bg-primary flex flex-row justify-center items-center hover:bg-secondary focus:outline-none focus:bg-secondary" type="submit">Daftar Sekarang</button>
            </label>
          </div>
        </form>
        <div className="pt-5">
          <p className="mb-5 text-sm font-medium text-center text-slate-500"> Sudah punya akun? <Link className="font-medium text-secondary hover:underline" to="/login">Masuk di sini</Link></p>
        </div>
      </div>
    </div>
  )
}

export default Register
